import type { AnnotationEntry } from '@geosoft/viewer-sdk';

export interface ViewshedSummary {
  readonly status: 'ready' | 'pending';
  readonly observerLabel: string;
  readonly engineStrategy: 'native-or-shim';
}

export function summarizeViewshed(annotations: ReadonlyArray<AnnotationEntry>): ViewshedSummary {
  const observer = annotations.find(
    (annotation) =>
      (annotation.kind === 'point' || annotation.kind === 'utility:utility-tap') &&
      annotation.geometry.type === 'Point',
  );

  if (!observer) {
    return {
      status: 'pending',
      observerLabel: 'place an observer point',
      engineStrategy: 'native-or-shim',
    };
  }

  return {
    status: 'ready',
    observerLabel: String(observer.properties.label ?? observer.kind),
    engineStrategy: 'native-or-shim',
  };
}
